import React from "react";
import { FiSettings } from "react-icons/fi";
import { GoPlus } from "react-icons/go";
import { Link } from "react-router-dom";
import { BiChevronRight } from "react-icons/bi";
import { BiChevronLeft } from "react-icons/bi";
import GenderTable from "./gender-table/GenderTable";
import { Pagination } from "antd";

const Genders = ({ data, getGenderData, onChangeVal, initialVlue, handleChange, reset }) => {
  return (
    <>
      <div className="pageTableWrapper">
        <div className="pageHeader">
          <div className="pageTitle">
            <FiSettings />
            <h5>Genders</h5>
          </div>
          <div className="addNew">
            <Link to="/admin/create-gender" className="btn btn-success">
              <GoPlus /> Add New Genders
            </Link>
          </div>
        </div>

        <div className="pageBody">
          <GenderTable data={data} getGenderData={getGenderData} initialVlue={initialVlue} handleChange={handleChange} reset={reset} />
        </div>

        <div className="pageFooter">
          <div className="row">
            <div className="col-md-6">
              <div className="showEntry">
                <p>Showing {data?.totalCount} entries</p>
              </div>
            </div>
            <div className="col-md-6">
              <Pagination
                defaultCurrent={1}
                onChange={onChangeVal}
                total={data?.totalCount}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Genders;
